<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" :href="route('dashboard')">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.dashboard') }}</div>
      </Link>
    </div>
    <template v-if="isAdmin || isSupervisor">
      <div class="mb-4">
        <Link class="group flex items-center py-3" :href="route('users')">
          <icon name="users" class="mr-2 w-4 h-4" :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.users') }}</div>
        </Link>
      </div>
    </template>
    <template v-if="isAdmin">
      <div class="mb-4">
        <a class="group flex items-center py-3" :href="route('comments')">
          <icon name="chat" class="mr-2 w-4 h-4" :class="isUrl('comments') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('comments') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.comments') }}</div>
        </a>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" :href="route('sheets')">
          <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('sheets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('sheets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.sheets') }}</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" :href="route('streets')">
          <icon name="map" class="mr-2 w-4 h-4" :class="isUrl('streets') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('streets') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.streets') }}</div>
        </Link>
      </div>
      <div class="mb-4">
        <a class="group flex items-center py-3" :href="route('queue-monitor::index')">
          <icon name="calendar" class="mr-2 w-4 h-4" :class="isUrl('jobs') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('jobs') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.jobs') }}</div>
        </a>
      </div>
      <div class="mb-4">
        <a class="group flex items-center py-3" :href="'/translations'">
          <icon name="language" class="mr-2 w-4 h-4" :class="isUrl('translations') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('translations') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.translations') }}</div>
        </a>
      </div>
    </template>
    <template v-if="isSupervisor">
      <div class="mb-4">
        <Link class="group flex items-center py-3" :href="route('keys')">
          <icon name="key" class="mr-2 w-4 h-4" :class="isUrl('keys') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('keys') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.keys') }}</div>
        </Link>
      </div>
      <div class="mb-4">
        <Link class="group flex items-center py-3" :href="route('keys.list')">
          <icon name="list" class="mr-2 w-4 h-4" :class="isUrl('keys/list') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('keys/list') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.keys_list') }}</div>
        </Link>
      </div>
    </template>
    <template v-if="isSupervisor || isMaster">
      <div class="mb-4">
        <Link class="group flex items-center py-3" :href="route('keys.my')">
          <icon name="lock-open" class="mr-2 w-4 h-4" :class="isUrl('keys/my') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
          <div :class="isUrl('keys/my') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">{{ $t('main_menu.my_keys_list') }}</div>
        </Link>
      </div>
    </template>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl === url).length
    },
  },
}
</script>
